import { RootState } from './../../../store';

export const firstModalInQueueSelector = (state: RootState) => state.modal.queue.items[0];

export const modalQueueLengthSelector = (state: RootState) => state.modal.queue.items.length;
